//Record status
export const ERROR = 'ERROR';
export const CREATING = 'CREATING';
export const DELIVERED = 'DELIVERED';
export const WITHOUT_INFORMATION = 'WITHOUT_INFORMATION';


//Filter status
export const FINISHED = 'FINISHED';
export const UNKNOWN = 'UNKNOWN';
export const INCOMPLETE = 'INCOMPLETE';
